module.exports = __webpack_public_path__ + "img/1sb_five_stars_unselected_google_d.6522e4a.svg";